import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { NavigationTab, NavigationProps, TAB_CONFIGS } from '../types/navigation';
import { appConfig } from '../config/configManager';

export const BottomNavigation: React.FC<NavigationProps> = ({ 
  activeTab, 
  onTabChange 
}) => {
  // Primary tabs that are always visible in the bottom navigation
  const primaryTabs: NavigationTab[] = [
    'ChildNav',     // Home
    'Milestones',   // Milestones 
    'Concerns',     // Concerns
    'Activities',   // Activities
    'Well-Visit',   // Well-Visit
    'More'          // More menu
  ];

  return (
    <View style={styles.outerContainer}>
      <View style={[styles.container, { maxWidth: appConfig.getFooterWidthMax() }]}>
      {primaryTabs.map((tab) => {
        const config = TAB_CONFIGS[tab];
        const isActive = activeTab === tab;
        
        return (
          <TouchableOpacity
            key={tab}
            style={[styles.tab, isActive && styles.activeTab]}
            onPress={() => onTabChange(tab)}
            accessibilityLabel={`Navigate to ${config.label}`}
            accessibilityRole="button"
          >
            <Text style={[styles.icon, isActive && styles.activeIcon]}>
              {config.icon}
            </Text>
            <Text style={[styles.label, isActive && styles.activeLabel]} numberOfLines={1}>
              {config.label}
            </Text>
          </TouchableOpacity>
        );
      })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    backgroundColor: '#ffffff',
    borderTopWidth: 1,
    borderTopColor: '#e1e8ed',
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    width: '100%',
    alignItems: 'center',
  },
  container: {
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 8,
    width: '100%',
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 6,
    borderRadius: 8,
    marginHorizontal: 2,
    minWidth: 0, // Allow tabs to shrink if needed
  },
  activeTab: {
    backgroundColor: '#f0f8ff',
  },
  icon: {
    fontSize: 20,
    marginBottom: 2,
  },
  activeIcon: {
    transform: [{ scale: 1.1 }],
  },
  label: {
    fontSize: 10,
    color: '#7f8c8d',
    textAlign: 'center',
    fontWeight: '500',
    flexShrink: 1, // Allow text to shrink if needed
  },
  activeLabel: {
    color: '#3498db',
    fontWeight: '600',
  },
});